import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const MONTHS_IT = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];

export const STATUS_LABELS = { da_assegnare: 'Da assegnare', assegnata: 'Assegnata', in_corso: 'In corso', completata: 'Completata' };
export const STATUS_COLORS = {
  da_assegnare: 'bg-orange-100 text-orange-700 border-orange-200',
  assegnata: 'bg-blue-100 text-blue-700 border-blue-200',
  in_corso: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  completata: 'bg-emerald-100 text-emerald-700 border-emerald-200'
};

export const MonthNav = ({ month, year, prevMonth, nextMonth }) => (
  <div className="flex items-center gap-1 sm:gap-2">
    <button onClick={prevMonth} className="p-1.5 sm:p-2 hover:bg-white rounded" data-testid="prev-month"><ChevronLeft size={18} /></button>
    <span className="font-semibold text-[#0A1312] min-w-[120px] sm:min-w-[160px] text-center text-xs sm:text-sm">{MONTHS_IT[month]} {year}</span>
    <button onClick={nextMonth} className="p-1.5 sm:p-2 hover:bg-white rounded" data-testid="next-month"><ChevronRight size={18} /></button>
  </div>
);

export const StatCard = ({ label, value, color = 'text-[#0A1312]' }) => (
  <div className="bg-white rounded-lg border border-[#E2E8F0] p-4 shadow-sm">
    <p className="text-xs text-[#0A1312]/70 uppercase tracking-wider">{label}</p>
    <p className={`text-2xl font-bold mt-1 ${color}`}>{value}</p>
  </div>
);
